// extracted by mini-css-extract-plugin
export default {"glass":"style_glass__-+kud","tyre":"style_tyre__lYNfT"};